import { Button, Grid } from '@mui/material';
import { Container } from '@mui/system';
import React from 'react';

const ButtonRow = ({ button1Label, button2Label, button1Callback, button2Callback, button1Color, button2Color, button1Sx, button2Sx }) => {
    // const handleButton1Click = () => {
    //     if (button1Callback) {
    //         button1Callback();
    //     }
    // };

    // const handleButton2Click = () => {
    //     if (button2Callback) {
    //         button2Callback();
    //     }
    // };

    return (
        <Grid container spacing={2} sx={{ justifyContent: 'flex-end', pt: 5 }}>
            {button1Label && <Grid item>
                <Button
                    color={button1Color}
                    variant="outlined"
                    size="small"
                    // type="submit"
                    sx={button1Sx}
                    onClick={button1Callback}
                >
                    {button1Label}
                </Button>
            </Grid>}
            {button2Label && <Grid item>
                <Button
                    color={button2Color}
                    variant="outlined"
                    size="small"
                    sx={button2Sx}
                    onClick={button2Callback}
                >
                    {button2Label}
                </Button>
            </Grid>}
        </Grid>

    );
};

export default ButtonRow;